<body>


    <div class="main-wrapper">
        <div class="main-content">
            <header>

                <div class="head-line">

                    <p>Staff Call Performance</p>


                </div>
                <div class="user-wrapper">
                    <p>{{storedData.agencyRefId.agencyName}}</p>

                    <div>
                        <img class="log1"
                            [src]="this.storedData.agencyRefId.logo?this.storedData.agencyRefId.logo:'../../../../assets/../../assets/images/user1.jpeg'">
                    </div>
                </div>
            </header>
            <main class="main-2">
                <div class="report-container" style="margin-left: 30px;height: auto;width:100%;">
                    <h2 class="report-header">Staff Call Performance Report</h2>

                    <div class="filter-box">
                        <label for="date" *ngIf="reportType=='daily'">Select Date:</label>
                        <label for="date" *ngIf="reportType=='monthly'">Select Month:</label>
                        <input type="date" id="date" [(ngModel)]="selectedDate" *ngIf="reportType=='daily'">
                        <input type="month" id="date" [(ngModel)]="selectedMonth" *ngIf="reportType=='monthly'" (input)="getcurrentMonthAndYear()">
                        <button class="btn" (click)="generateReport()">Generate Report</button>
                        <button class="btn" (click)="monthlyReport('monthly')" *ngIf="reportType=='daily'">Monthly Report</button>
                        <button class="btn" (click)="monthlyReport('daily')" *ngIf="reportType=='monthly'">Daily Report</button>
                    </div>

                    <table *ngIf="reportType=='daily'">
                        <thead>
                            <tr>
                                <th style="color: white !important;">No.</th>
                                <th style="color: white !important;">Staff</th>
                                <th style="color: white !important;">Code</th>
                                <th style="color: white !important;">Answered Calls</th>
                                <th style="color: white !important;">Not Answered</th>
                                <th style="color: white !important;">Total Calls</th>
                                <th style="color: white !important;">Outgoing Time</th>
                                <th style="color: white !important;">Incoming Time</th>
                                <th style="color: white !important;">Total Time</th>
                                <th style="color: white !important;">First Call</th>
                                <th style="color: white !important;">Last Call</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of dailyData;let i = index;">
                                <td>{{ i+1 }}</td>
                                <td (click)="copyText(item.staffName)" title="Click to copy">{{ item.staffName}}</td>
                                <td (click)="copyText(item.staffCode)" title="Click to copy">{{ item.staffCode}}</td>
                                <td>{{ item.answeredCalls}}</td>
                                <td>{{ item.notAnsweredCalls}}</td>
                                <td>{{ item.totalCalls}}</td>
                                <td>{{minutesToHHMMSS(item.outgoingCallTime)}}</td>
                                <td>{{minutesToHHMMSS(item.incomingCallTime)}}</td>
                                <td>{{minutesToHHMMSS(item.totalCallTime)}}</td>
                                <td class="cell-red" *ngIf="item.firstCall">{{  formatUTCTime(item.firstCall)}}</td>
                                <td class="cell-blue" *ngIf="!item.firstCall">N/A</td>
                                <td class="cell-red" *ngIf="item.lastCall">{{ formatUTCTime(item.lastCall)}}</td>
                                <td class="cell-blue" *ngIf="!item.lastCall">N/A</td>
                            </tr>
                          
                        </tbody>
                    </table>

                     <div class="table-container" *ngIf="reportType=='monthly'">
                        <table class="table table-bordered table-striped text-center align-middle" *ngIf="reportType=='monthly'">
                            <thead class="table-header">
                                <tr>
                                <th style="color: white !important;">STAFF NAME</th>
                                <th *ngFor="let day of days" style="color: white !important;">DAY {{day | date:'dd'}}<br><small>(MIN)</small></th>
                                <th style="color: white !important;">MONTHLY TOTAL<br><small>(HH:MM)</small></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let staff of monthlyData">
                                <td class="staff-name">{{staff.staffName}}</td>
                                <td
                                    *ngFor="let min of staff.dailyStats"
                                    [ngClass]="{
                                    'zero-cell': min.totalCallTime === 0,
                                    'value-cell': min.totalCallTime > 0
                                    }"
                                >
                                    {{min.totalCallTime}}
                                </td>
                                <td class="total-time">{{minutesToHHMMSS(staff.total)}}</td>
                                </tr>
                            </tbody>
                        </table>
                      </div>  
                </div>
            </main>
        </div>
    </div>
    <div class="footer-section2">

        <img src="../../assets/images/accruon-footer (2).png">
    </div>
</body>